// extracted by mini-css-extract-plugin
module.exports = {"PaginationButton":"PaginationButton_PaginationButton__XwwHK","inverse":"PaginationButton_inverse__2UQL5"};